<template>
    <div class="bg-white shadow overflow-hidden sm:rounded-lg">
        <div class="px-4 py-5 border-b border-gray-200 sm:px-6" v-if="heading">
            <div class="flex items-center justify-between">
                <h4 class="text-lg leading-6 text-gray-900">{{ heading }}</h4>
                <slot name="header"></slot>
            </div>

            <p class="mt-1 max-w-2xl text-sm leading-5 text-gray-500"
               v-if="description"
            >
                {{ description }}
            </p>
        </div>
        <div class="px-4 py-5 sm:p-0">
            <dl>
                <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-5 mt-8 first:mt-0 sm:mt-0 first:border-t-0 sm:border-t sm:border-gray-200"
                     v-for="item in listItems"
                >
                    <dt class="text-sm leading-5 font-medium text-gray-500">
                        {{ item.name }}
                    </dt>
                    <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
                        v-html="item.value"
                    ></dd>
                </div>
            </dl>
        </div>

        <slot></slot>
    </div>

</template>

<script>
    export default {
        props: {
            heading: {
                type: String,
            },

            description: {
                type: String,
            },

            listItems: {
                type: Array,
                required: true,
            }
        }
    }
</script>
